/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */

export const CPROF_CREATE = "CPROF_CREATE";
export const CPROF_CREATE_SUCCESS = "CPROF_CREATE_SUCCESS";
export const CPROF_CREATE_FAILURE = "CPROF_CREATE_FAILURE";
export const CPROF_FETCH_ALL = "CPROF_FETCH_ALL";
export const CPROF_FETCH_ALL_SUCCESS = "CPROF_FETCH_ALL_SUCCESS";
export const CPROF_FETCH_ALL_FAILURE = "CPROF_FETCH_ALL_FAILURE";
export const CPROF_DELETE = "CPROF_DELETE";
export const CPROF_DELETE_SUCCESS = "CPROF_DELETE_SUCCESS";
export const CPROF_DELETE_FAILURE = "CPROF_DELETE_FAILURE";
export const CPROF_UPDATE = "CPROF_UPDATE";
export const CPROF_UPDATE_SUCCESS = "CPROF_UPDATE_SUCCESS";
export const CPROF_UPDATE_FAILURE = "CPROF_UPDATE_FAILURE";
